import React from "react";
import dayjs from "dayjs";
import { Col, Empty, Row, Spin } from "antd";
import OrganistionSubscriptionForm from "./subscriptionForm";

const SubscriptionModal = ({
  isLoading,
  subscriptionList,
  subscriptionSubmit,
  subscriptionDetails,
  setSubscriptionDetails,
}) => {
  return subscriptionDetails?.loader ? (
    <Row align={"middle"} justify={"center"} className="mt2">
      <Col>
        <Spin tip="Loading" size="large" className="mt2" />
      </Col>
    </Row>
  ) : subscriptionDetails?.data ? (
    <Row gutter={[16, 16]} justify="center" className="mt2">
      <Col span={22}>
        <Row>
          <Col span={6} className="subscription-label">
            Name:
          </Col>
          <Col span={18}>{subscriptionDetails?.data?.comboPlanName}</Col>
        </Row>
      </Col>
      <Col span={22}>
        <Row>
          <Col span={6} className="subscription-label">
            Status:
          </Col>
          <Col
            span={18}
            className={
              !subscriptionDetails?.data?.endDate
                ? "subscription-active"
                : "subscription-deactive"
            }
          >
            {!subscriptionDetails?.data?.endDate ? "ACTIVE" : "DEACTIVE"}
          </Col>
        </Row>
      </Col>
      <Col span={22}>
        <Row>
          <Col span={6} className="subscription-label">
            Start date:
          </Col>
          <Col span={18}>
            {dayjs(subscriptionDetails?.data?.startDate).format("DD MMM YYYY")}
          </Col>
        </Row>
      </Col>
    </Row>
  ) : subscriptionDetails?.addModel ? (
    <OrganistionSubscriptionForm
      subscriptionList={subscriptionList}
      handleSubmit={subscriptionSubmit}
      isLoading={isLoading}
    />
  ) : (
    <Row align={"middle"} justify={"center"} className="mt2">
      <Col span={24}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data">
          {/* <div>No Subscription details</div> */}
          <div
            className="add-subscription-btn"
            onClick={() =>
              setSubscriptionDetails((prev) => ({
                ...prev,
                viewModel: true,
                addModel: true,
              }))
            }
          >
            {"Add Subscription"}
          </div>
        </Empty>
        {/* <Button
          type="primary"
          variant="link"
          className=""
          
        >
          {"Add Subscription"}
        </Button> */}
      </Col>
    </Row>
  );
};

export default SubscriptionModal;
